'use client';
import { useTranslate } from '@tolgee/react';
import { useEffect } from 'react';

import { logError } from '@/lib/logError';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { t } = useTranslate();

  useEffect(() => {
    // Log the error with more context
    console.log('GlobalError', error);

    void logError({
      message: `Global Error: ${error.message}`,
      error,
      context: {
        digest: error.digest,
        stack: error.stack,
      },
    });
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <h2 className="mb-4 text-2xl font-bold">{t('page.error.title', 'Something went wrong!')}</h2>
      <button onClick={reset} className="rounded bg-primary px-4 py-2 text-white hover:bg-primary/90">
        {t('page.error.reset', 'Try again')}
      </button>
    </div>
  );
}
